export default __webpack_public_path__ + "static/media/work-5a.d3c36fd4.png";